// extracted by mini-css-extract-plugin
module.exports = {"link":"_9e1425b4d3--link--CZZLZ"};